import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import IEStatefulBase from './IEStatefulBase';

export default class IESelect extends IEStatefulBase {
    static propTypes = {
        options: PropTypes.array.isRequired
    };

    getSelectedOption = () => {
        let value = (!!this.state.newValue) ? this.state.newValue : this.props.value;
        let option = this.props.options.find(function (o) {
            return o.value === value;
        }, this)
        return option;
    }

    finishEditing = (selectedOption) => {
        // get the object from options that matches user selected value
        const newValue = selectedOption.value;
        this.doValidations(newValue);
        if(!this.state.invalid && this.props.value !== newValue) {
            this.commit(newValue);
        }
        this.cancelEditing();
    };

    renderEditingComponent = () => {
        return <Select
            {...this.props.editProps}
            className={this.makeClassString()}
            options={this.props.options}
            onChange={this.finishEditing}
            value={this.getSelectedOption()}
            clearable={false}
            resetValue={[]}
            ref="input"
        />
    };

    renderNormalComponent = () => {                
        return <span
            tabIndex="0"
            className={this.makeClassString()}
            onFocus={this.startEditing}
            onClick={this.startEditing}
            {...this.props.defaultProps}>{this.getSelectedOption().label}</span>;
    };
}



// WEBPACK FOOTER //
// ./src/components/InlineEdit/IESelect.js